import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './RoleList.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;


const RoleList = () => {
  const [role, setRole] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const response = await axios.get(`${url}/api/role`);
        setRole(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch Role');
      } finally {
        setLoading(false);
      }
    };

    fetchRole();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${url}/api/role/${id}`);
      setRole(role.filter(role => role._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete Role');
    }
  };

  if (loading) return <div className="loading">Loading Role...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="countries-container">
      <div className="header">
        <h2>Role List</h2>
        <button 
          onClick={() => navigate('/AddRole')}
          className="add-button"
        >
          <Plus size={16} /> Add Role
        </button>
      </div>

      <table className="countries-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {role.map(role => (
            <tr key={role._id}>
              <td>{role.name}</td>
              <td className="actions">
                <button 
                  onClick={() => navigate(`/role/edit/${role._id}`)}
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>
                {/* <button 
                  onClick={() => handleDelete(role._id)}
                  className="delete-btn"
                >
                  <Trash2 size={14} />
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RoleList;